import React, {useEffect, useState} from 'react';
import Loader from '../../components/Loader';
import { useUser } from '../../contexts/UserContext';
import DataTable from '../table/Datatable';
import PrimaryButton from '../../components/buttons/PrimaryButton';
import ToggleActivationLink from '../actions/ToggleActivationLink';
import AddChef from '../actions/AddChef';
import AddResponsable from '../actions/AddResponsable';
import { collection, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import { db } from '../../firebase';

const ListUtilisateurs = () => {

  //contexte de l'utilisateur connecté
  const user = useUser();
  const [utilisateurs, setUtilisateurs] = useState([]); 
  const [loader, setLoader] = useState(true); 

  const [creerChef, popupCreerChef] = useState(false);
  const [creerResponsable, popupCreerResponsable] = useState(false);

  useEffect(()=> {
    loadData();
  }, []); 

  const loadData = () => {
    const collectionRef = collection(db, 'utilisateurs');
    
    const collectionQuery = query(collectionRef, where('type', '!=', 'operateur'),  orderBy("nomClient", "asc"))

    const unsubscribe = onSnapshot(
      collectionQuery,
      (snapshot) => {
        const items = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setUtilisateurs(items);
        setLoader(false);
      },
      (error) => {
        console.error("Error fetching collection:", error);
        setLoader(false);
      }
    );

    return () => unsubscribe();
  }

  const columns = [
    { header: 'Prénom', render: (user) => user.prenom },
    { header: 'Nom', render: (user) => user.nom },
    { header: 'Client', render: (user) => user.nomClient },
    { header: 'Type de compte', render: (user) => user.type },
    { header: 'Email', render: (user) => user.email },
    { header: 'Active', render: (user) => (user.active ? "Activé" : "Désactivé") },
    { header: 'Action', render: (user) => (<ToggleActivationLink collection={`utilisateurs/`} item={user} available={true} /> )}
  ];

  return (
    <div>
      <div className='flex gap-2 justify-end'>
        <a href="#" onClick={() => popupCreerChef(true)} className="justify-end flex mb-4">
          <PrimaryButton type={"button"} value={"Créer un compte chef"} loading={false} />
        </a>
        
        <a href="#" onClick={() => popupCreerResponsable(true)} className="justify-end flex mb-4">
          <PrimaryButton type={"button"} value={"Créer un compte responsable"} loading={false} />
        </a>
      </div>
   
      {loader ? (
        <Loader />
      ) : (
        <DataTable 
          data={utilisateurs} 
          columns={columns} 
          onRowClick={(user) => console.log("Utilisateur")}
        />
      )}

      {creerChef ? (
        <AddChef onClose={() => popupCreerChef(false)} />
      ) : null }

      {creerResponsable ? (
        <AddResponsable onClose={() => popupCreerResponsable(false)} />
      ) : null }
    </div>
  );
};

export default ListUtilisateurs;
